import policyDetailsView from 'text!../policyDetails/policyDetails.html';
import policyDetailsCtrl from '../policyDetails/policyDetailsCtrl';
import generalCoveragesView from 'text!../generalCoverages/generalCoverages.html';
import generalCoveragesCtrl from '../generalCoverages/generalCoveragesCtrl';
import additionalCoveragesView from 'text!../additionalCoverages/additionalCoverages.html';
import additionalCoveragesCtrl from '../additionalCoverages/additionalCoveragesCtrl';
import locationsAndBuildingsView from 'text!../locationsAndBuildings/locationsAndBuildings.html';
import quoteView from 'text!../quote/quote.html';
import quoteCtrl from '../quote/quoteCtrl';
import paymentDetailsView from 'text!../paymentDetails/paymentDetails.html';

export default (function () {
    var wizardParentState = 'baseTransactionWizard';

    return {
        renewalBopPolicyDetails: {
            parent: wizardParentState,
            template: policyDetailsView,
            controller: policyDetailsCtrl
        },
        renewalBopGeneralCoverages: {
            parent: wizardParentState,
            template: generalCoveragesView,
            controller: generalCoveragesCtrl
        },
        renewalBopAdditionalCoverages: {
            parent: wizardParentState,
            template: additionalCoveragesView,
            controller: additionalCoveragesCtrl
        },
        renewalBopLocationsAndBuildings: {
            parent: wizardParentState,
            template: locationsAndBuildingsView
        },
        renewalBopQuote: {
            parent: wizardParentState,
            template: quoteView,
            controller: quoteCtrl
        },
        renewalBopPaymentDetails: {
            parent: wizardParentState,
            template: paymentDetailsView
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-policytransaction-renewal-bop-angular/config/RouteConfig.js
// module id = 1864
// module chunks = 0